import React from "react";

import DownloadMessage from "./DownloadMessage";
import { BorderBottomLink } from "core/Typography";

const DownloadMessageRoyaltyFree = () => (
    <DownloadMessage>
        Royalty-Free license{" "}
        <BorderBottomLink
            mode="dark"
            linkType="primary"
            href="/legal/terms-of-use/#icon-licenses"
            target="_blank"
        >
            More info
        </BorderBottomLink>
    </DownloadMessage>
);

export default DownloadMessageRoyaltyFree;
